import React from "react";
import InfoCircle from "../assets/icons/info-circle-solid.svg";
import Times from "../assets/icons/times-light.svg";
import { useGlobalState } from "../context/Global";

const _cache = JSON.parse(localStorage.getItem("CHECKLIST_NOTIFICATIONS"));

function Notification({ id, type, notification }) {
  const { data } = useGlobalState();
  const [notifications, setNotifications] = React.useState(_cache || []);

  const handleToggleNotification = (id, value = null) => {
    setNotifications((prevState) => {
      const newState = {
        ...prevState,
        ...{
          [id]: {
            isOpen: value === null ? !prevState[id]?.isOpen : value,
          },
        },
      };
      localStorage.setItem("CHECKLIST_NOTIFICATIONS", JSON.stringify(newState));
      return newState;
    });
  };

  return type === "info" ? (
    !notifications[id] || notifications[id]?.isOpen ? (
      <div className="flex relative bg-secondary-dark text-white px-4 py-8 mb-3 ">
        <div className="flex-grow-0 flex-shrink-0 flex items-center mr-4">
          <InfoCircle width="24" height="24" />
        </div>
        <div className="flex-grow pr-4" dangerouslySetInnerHTML={{ __html: data?.info }}></div>
        <Times width="24" height="24" className="absolute right-0 top-0 mt-2 mr-2 cursor-pointer" onClick={() => handleToggleNotification(id, false)} />
      </div>
    ) : null
  ) : notification ? (
    <div className="bg-gray-200 p-4 mb-8">
      <div className="flex justify-between">
        <div>
          <b>{notification.title}</b>
          {((notifications && !notifications[id]) || notifications[id]?.isOpen) && (
            <div
              dangerouslySetInnerHTML={{
                __html: notification.body,
              }}
            />
          )}
        </div>
        {notifications && notifications[id] && !notifications[id].isOpen && (
          <div className="flex justify-end">
            <a className="text-primary-dark underline cursor-pointer" onClick={() => handleToggleNotification(id, true)}>
              see it again
            </a>
          </div>
        )}
      </div>
      {(!notifications[id] || notifications[id]?.isOpen) && (
        <div className="flex justify-end">
          <div className="flex items-center mr-2">{notification?.$["action-label"]}</div>
          <button className="bg-primary-dark text-white px-4 py-2" onClick={() => handleToggleNotification(id, false)}>
            {notification?.$["action-button"]}
          </button>
        </div>
      )}
    </div>
  ) : null;
}

export default Notification;
